import type {
  PrintStatus,
  PurchasePrintStatus,
  PurchaseCancellation,
  PurchaseCommittedSnapshot,
  PurchaseHistoryItem,
} from './purchases.dto.js';

export const purchaseHistoryCancellationStateValues = ['all', 'only', 'exclude'] as const;
export type PurchaseHistoryCancellationState =
  (typeof purchaseHistoryCancellationStateValues)[number];

export interface ListPurchaseHistoryRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  from?: string;
  to?: string;
  page?: number;
  pageSize?: number;
  search?: string;
  cancellationState?: PurchaseHistoryCancellationState;
  printStatus?: PurchasePrintStatus;
  operatorUserId?: string;
}

export interface ListPurchaseHistoryResponse {
  items: PurchaseHistoryItem[];
  page: number;
  pageSize: number;
  hasMore: boolean;
  total?: number;
}

export interface GetPurchaseHistoryRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  purchaseId: string;
}

export interface GetPurchaseHistoryResponse {
  purchase: PurchaseCommittedSnapshot;
  printStatus: PrintStatus;
  cancellation: PurchaseCancellation | null;
}
